import { useState } from 'react';
import { StudentRow } from './types';

type Severity = 'success' | 'info' | 'warn' | 'error';
type Trigger = (arg: any) => { unwrap: () => Promise<any> };

interface Deps {
  schoolId: number;
  removeStudentLocally: (userId: string | number) => void;
  refetchExposure: () => void;
  postExposureVisit: Trigger;
  notify: (s: Severity, summary: string, detail: string) => void;
}

// Remove-Student dialog state + confirm/remove handlers.
export function useRemoveStudent(d: Deps) {
  const [removeRow, setRemoveRow] = useState<StudentRow | null>(null);
  const [removeReason, setRemoveReason] = useState<number | ''>('');
  const [removeOther, setRemoveOther] = useState('');
  const [removeSubmitted, setRemoveSubmitted] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  function confirmDelete(row: StudentRow) {
    setRemoveRow(row);
    setRemoveReason('');
    setRemoveOther('');
    setRemoveSubmitted(false);
  }
  const closeRemove = () => setRemoveRow(null);
  const onRemoveReasonChange = (v: number | '') => {
    setRemoveReason(v);
    setRemoveOther('');
  };

  async function onRemoveConfirm() {
    setRemoveSubmitted(true);
    if (!removeRow || !removeReason) return;
    if (removeReason == 7 && !removeOther.trim()) return;

    setIsRemoving(true);
    try {
      const records = {
        IndxID: removeRow.IndxID,
        SchlId: d.schoolId,
        StudId: removeRow.user_id,
        Isactive: '0',
        Noreason: removeReason,
        OtherReason: removeReason == 7 ? removeOther.trim() : '',
      };
      const res = await d.postExposureVisit({ records }).unwrap();
      if (res?.dataStatus) {
        d.notify('success', 'Removed', res.message || 'Student removed.');
        d.removeStudentLocally(removeRow.user_id);
        d.refetchExposure();
        setRemoveRow(null);
      } else d.notify('warn', 'Warning', res?.message || 'Unable to remove.');
    } catch {
      d.notify('error', 'Error', 'Something went wrong. Please try again.');
    } finally {
      setIsRemoving(false);
    }
  }

  return {
    removeRow,
    removeReason,
    removeOther,
    setRemoveOther,
    removeSubmitted,
    isRemoving,
    closeRemove,
    onRemoveReasonChange,
    onRemoveConfirm,
    confirmDelete,
  };
}
